import Chart from 'chart.js/auto';
const chartjs = require('../../../../../../components/chart/chartjs');

export function createTreemapChart(a) {
    const chartContainer = document.querySelector('.card-chart');
    if (!chartContainer) return;

    chartContainer.innerHTML = '<canvas class="chartjs" id="itemTreemapChart"></canvas>';
    const canvas = document.getElementById('itemTreemapChart');

    const existingChart = Chart.getChart(canvas);
    if (existingChart) {
        existingChart.destroy();
    }


    const data = [
        { name: 'Avocado', value: 42 },
        { name: 'Banana', value: 18 },
        { name: 'Carrot', value: 35 },
        { name: 'Cilantro', value: 11 },
        { name: 'Lettuce', value: 27 },
        { name: 'Aloe', value: 19 },
        { name: 'Apio', value: 23 },
        { name: 'Yam', value: 7 },
        { name: 'Cucumber', value: 38 },
        { name: 'Tomato', value: 34 },
        { name: 'Onion', value: 9 },
        { name: 'Apple', value: 20 },
        { name: 'Pear', value: 15 },
        { name: 'Orange', value: 17 },
        { name: 'Pepper', value: 22 },
        { name: 'Watermelon', value: 12 },
        { name: 'Grape', value: 21 },
        { name: 'Yucca', value: 6 },
        { name: 'Spinach', value: 16 },
        { name: 'Broccoli', value: 31 },
        { name: 'Pumpkin', value: 8 },
        { name: 'Radish', value: 25 },
        { name: 'Cabbage', value: 13 },
        { name: 'Pineapple', value: 37 },
        { name: 'Blueberry', value: 29 },
        { name: 'Strawberry', value: 39 },
        { name: 'Mango', value: 10 },
        { name: 'Peach', value: 33 },
        { name: 'Plum', value: 32 },
        { name: 'Cherry', value: 40 },
        { name: 'Lime', value: 30 },
        { name: 'Lemon', value: 26 },
        { name: 'Eggplant', value: 24 },
        { name: 'Zucchini', value: 14 },
        { name: 'Beet', value: 36 },
        { name: 'Kiwi', value: 3 },
        { name: 'Mandarin', value: 28 },
        { name: 'Papaya', value: 2 },
        { name: 'Guava', value: 41 },
        { name: 'Melon', value: 5 },
        { name: 'Raspberry', value: 4 },
        { name: 'Pomegranate', value: 1 },
        { name: 'Artichoke', value: 44 },
        { name: 'Coconut', value: 43 },
        { name: 'Celery', value: 45 },
        { name: 'Fig', value: 46 },
        { name: 'Persimmon', value: 47 },
        { name: 'Olive', value: 49 },
        { name: 'Blackberry', value: 50 },
        { name: 'Apricot', value: 48 }
    ];

    chartjs.start({
        elem: 'treemap',
        act: 'createSimple',
        targetChart: { html: canvas },
        data: data,
        options: {
            responsive: true,
            aspectRatio: false,
            aspectRatio: 10 / 10,
            
        }
    });
}